import { Modal, Typography } from 'antd';

const ExportCSVModal = ({ exportTriggered, modalTitle, onClose, onExport, showModal, text }) => {
  if (!exportTriggered)
    return (
      <Modal
        data-testid="export-modal"
        title={modalTitle}
        closable
        cancelText="Cancel"
        okText="Export"
        open={showModal}
        onCancel={onClose}
        onOk={onExport}
      >
        {text}
      </Modal>
    );
  else
    return (
      <Modal
        data-testid="export-modal"
        title={modalTitle}
        open={showModal}
        okText="Close"
        onOk={onClose}
        onCancel={onClose}
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        {text}
      </Modal>
    );
};

export default ExportCSVModal;
